import { baseMarkPattern } from './__base'
export const subsup = function subsup (text, attrs) {
  if (attrs.type === 'sub') {
    return baseMarkPattern(text, '{~}')
  } else {
    return baseMarkPattern(text, '{^}')
  }
}
